var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fi-rr-time-delete",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6100",
    "data-name": "Path 6100",
    d: "M23.707,15.293a1,1,0,0,0-1.414,0L19.5,18.086l-2.793-2.793a1,1,0,1,0-1.414,1.414L18.086,19.5l-2.793,2.793a1,1,0,1,0,1.414,1.414L19.5,20.914l2.793,2.793a1,1,0,1,0,1.414-1.414L20.914,19.5l2.793-2.793a1,1,0,0,0,0-1.414Z",
    fill: "#fc7886"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6101",
    "data-name": "Path 6101",
    d: "M12,22A10,10,0,1,1,22,12a1,1,0,0,0,2,0A12,12,0,1,0,12,24a1,1,0,0,0,0-2Z",
    fill: "#fc7886"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6102",
    "data-name": "Path 6102",
    d: "M12,6a1,1,0,0,0-1,1v4.586L8.293,14.293a1,1,0,1,0,1.414,1.414l3-3A1,1,0,0,0,13,12V7a1,1,0,0,0-1-1Z",
    fill: "#fc7886"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedClock);
export default __webpack_public_path__ + "static/media/red-clock.431c11c5.svg";
export { ForwardRef as ReactComponent };